import { render } from "./FormGroupCheckbox.vue?vue&type=template&id=e1144ce4"
import script from "./FormGroupCheckbox.vue?vue&type=script&lang=js"
export * from "./FormGroupCheckbox.vue?vue&type=script&lang=js"

import "./FormGroupCheckbox.vue?vue&type=style&index=0&id=e1144ce4&lang=scss"

import exportComponent from "/Volumes/Storage/WebDevelopment/Fintax/new-gitlab/pajak.io/frontend-library-component-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__